<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(handleFormSubmit)">
      <div class="row">
        <div class="col-md-12">
          <div class="form-row d-flex justify-content-end">
            <div class="form-group p-2 m-0">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" id="series_enable" v-model="series.enable">
                <label class="form-check-label" for="series.enable">
                  Enable
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="id_sku">Series Title</label>
              <input
                type="text"
                class="form-control"
                id="id_sku"
                placeholder="Series Title"
                v-model="series.sku"
              />
            </div>
            <div class="form-group col-md-6">
              <label for="id_sku">Sorting Order</label>
              <select class="form-control" v-model="series.sorting_order">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="id_category">Category</label>
              <ValidationProvider rules="required" v-slot="{ errors }">
                <select
                  :class="errors.length === 0 ? '' : 'error'"
                  class="form-control"
                  v-model="series.product_category"
                >
                  <option value>-- None --</option>
                  <option
                    v-for="category in categories"
                    :key="category.id"
                    :value="category.id"
                  >{{ category.name }}</option>
                </select>
                <div class="text-danger">
                  <small>{{ errors[0] }}</small>
                </div>
              </ValidationProvider>
            </div>
            <div class="form-group col-md-6">
              <label for="id_types">Type</label>
              <select class="form-control" v-model="series.product_type">
                <option value>-- None --</option>
                <option v-for="type in types" :key="type.id" :value="type.id">{{ type.name }}</option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="id_short_description">Short Description</label>
              <textarea
                class="form-control"
                id="id_short_description"
                placeholder="Short Description"
                v-model="series.short_description"
              ></textarea>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-10">
              <label for="id_bullet_point1">Bullet Point 1</label>
              <input
                type="text"
                class="form-control"
                id="id_bullet_point1"
                placeholder="Bullet Point 1"
                v-model="series.bullet_point1"
              />
            </div>
            <div class="form-group col-md-10">
              <label for="id_bullet_point2">Bullet Point 2</label>
              <input
                type="text"
                class="form-control"
                id="id_bullet_point2"
                placeholder="Bullet Point 2"
                v-model="series.bullet_point2"
              />
            </div>
            <div class="form-group col-md-10">
              <label for="id_bullet_point3">Bullet Point 3</label>
              <input
                type="text"
                class="form-control"
                id="id_bullet_point3"
                placeholder="Bullet Point 3"
                v-model="series.bullet_point3"
              />
            </div>
            <div class="form-group col-md-10">
              <label for="id_bullet_point4">Bullet Point 4</label>
              <input
                type="text"
                class="form-control"
                id="id_bullet_point4"
                placeholder="Bullet Point 4"
                v-model="series.bullet_point4"
              />
            </div>
            <div class="form-group col-md-10">
              <label for="id_bullet_point5">Bullet Point 5</label>
              <input
                type="text"
                class="form-control"
                id="id_bullet_point5"
                placeholder="Bullet Point 5"
                v-model="series.bullet_point5"
              />
            </div>
          </div>
          <div class="form-row">
            <CustomFields
              :category="series.product_category === '' ? null : series.product_category"
              :series="series.id"
              @select="handleCustomFieldsSelect"
            />
          </div>
        </div>
        <!-- close col-md-12 -->
      </div>
      <!-- close row -->
      <div class="row">
        <div class="col-md-12 text-right">
          <button class="btn btn-primary btn-icon-splitfloat-right">{{ type }}</button>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import CustomFields from '@/components/Common/CustomFields.vue';
import SeriesApiRequest from '@/components/ApiRequester/Series.js';
import CategoryApiRequest from '@/components/ApiRequester/Category.js';
import TypeApiRequest from '@/components/ApiRequester/Type.js';
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
  name: 'SeriesForm',
  props: {
    type: {
      required: true,
      type: String,
      validator: (val) => ['Create', 'Update'].includes(val),
    },
    item: {
      required: false,
      type: Object,
      default: () => null,
    },
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    CustomFields
  },
  data: () => ({
    categories: [],
    types: [],
    series: {
      id: null,
      sku: '',
      sorting_order: 3,
      product_category: '',
      product_type: '',
      short_description: '',
      bullet_point1: '',
      bullet_point2: '',
      bullet_point3: '',
      bullet_point4: '',
      bullet_point5: '',
      enable: null
    },
    customFields: {},
  }),
  created() {
    if (this.$props.item !== null) {
      this.series = Object.assign(this.series, {
        id: this.$props.item.id,
        sku: this.$props.item.sku,
        sorting_order: this.$props.item.sorting_order,
        product_category: this.$props.item.product_category_id,
        product_type: this.$props.item.product_type_id,
        short_description: this.$props.item.short_description,
        bullet_point1: this.$props.item.bullet_point1,
        bullet_point2: this.$props.item.bullet_point2,
        bullet_point3: this.$props.item.bullet_point3,
        bullet_point4: this.$props.item.bullet_point4,
        bullet_point5: this.$props.item.bullet_point5,
        enable: this.$props.item.enable,        
      });
    }

    extend('required', {
      validate (value) {
        return {
          required: true,
          valid: ['', null, undefined].indexOf(value) === -1
        }
      },
      computesRequired: true,
      message: 'This field is required',
    });
  },
  mounted() {
    document.getElementById('loader').classList.add('active');
    Promise.all([
      this.fetchCategories(),
      this.fetchTypes(),
    ]).then(([categoryResources, typeResources]) => {
      this.categories = categoryResources;
      this.types = typeResources;

      document.getElementById('loader').classList.remove('active');
    }).catch(() => {
      document.getElementById('loader').classList.remove('active');
    });
  },
  methods: {
    handleCustomFieldsSelect(customFields) {
      this.customFields = customFields;
    },
    handleFormSubmit() {
      const ApiRequester = new SeriesApiRequest();
      this.series = Object.assign(this.series, {
        custom_fields: this.customFields,
      });

      let payload = { data: this.series };

      switch (this.$props.type) {
        case 'Create':
          payload = Object.assign(payload, { method: 'POST' });
          break;
        case 'Update':
          payload = Object.assign(payload, { method: 'PUT' });
          break;
      }

      document.getElementById('loader').classList.add('active');

      ApiRequester.store(payload).then((response) => {
        document.getElementById('loader').classList.remove('active');       
        if (response.data.error) {
          this.$emit('message',response.data.error)
        } else {
          this.$emit('submit');
        }       
      }).catch(() => {
        document.getElementById('loader').classList.remove('active');
      })
    },
    fetchCategories() {
      const ApiRequester = new CategoryApiRequest();
      return ApiRequester.all().then((response) => response.data.categories);
    },
    fetchTypes() {
      const ApiRequester = new TypeApiRequest();
      return ApiRequester.all().then((response) => response.data.types);
    }
  },
};
</script>

<style lang="scss" scoped>
.error {
  border-color: red;
}
</style>
